import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { CircularProgress } from '@material-ui/core';
import * as auth from "../_redux/authRedux";
import { loginWithFacebook } from "../_redux/authCrud";

function FacebookLogin(props) {
  const history = useHistory();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleFacebookLogin = async () => {
      try {
        console.log('🔵 Starting Facebook login...');
        
        await loginWithFacebook();
        
        console.log('✅ Facebook login successful');
        
        props.login();
        props.updateToken();
        
        console.log('🔄 Redirecting to dashboard...');
        history.push('/dashboard');
        
      } catch (err) {
        console.error('❌ Facebook login failed:', err);
        setError(err.message || 'Facebook login failed');
        
        setTimeout(() => {
          history.push('/auth/login');
        }, 3000);
      }
    };

    handleFacebookLogin();
  }, [history, props]);

  return (
    <div className="text-center" style={{ padding: '50px' }}>
      {!error ? (
        <>
          <h3>Logging in with Facebook...</h3>
          <CircularProgress style={{ marginTop: '20px' }} />
        </>
      ) : (
        <>
          <h3 style={{ color: 'red' }}>Login Failed</h3>
          <p>{error}</p>
          <p>Redirecting to login page...</p>
        </>
      )}
    </div>
  );
}

export default connect(null, auth.actions)(FacebookLogin);